import { ErrorExclamation } from "@monsterindia/global-ui-components";

export const ErrorText = ({ text }: { text: string }) => {
  return (
    <div className="l1-flex l1-items-center l1-gap-1">
      <ErrorExclamation width={13} height={13} className="!l1-fill-red-500" />
      <p className="l1-text-xs l1-text-red-500">{text}</p>
    </div>
  );
};
